import React, { useCallback, useEffect, useRef, useState } from 'react';

import TextField from '@atlaskit/textfield';

const Search = ({ filter, onFilterChange }) => {
  const [value, setValue] = useState('');
  const debounce = useRef(0);

  useEffect(() => { setValue(filter); }, [filter]);

  const onChange = useCallback(({ target: { value } }) => {
    setValue(value);
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      if (!debounce.current) return;
      debounce.current = 0;
      onFilterChange(value);
    }, 1000);
  }, [onFilterChange]);

  const onKeyPress = useCallback((event) => {
    if (event.key === 'Enter') {
      debounce.current = 0;
      onFilterChange(value);
    }
  }, [onFilterChange, value]);

  return (
    <div style={{ display: 'flex', marginRight: 3 }} data-cy="users-search-input">
      <TextField
        isCompact
        placeholder="Search..."
        width="medium"
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
    </div>
  );
};

export default Search;
